export const getColumnClasses = (plpSpeedEnabled, useVerticalPadding = false) => {
  const paddingClasses = useVerticalPadding ? 'sui-pb-4 sui-pt-4' : 'sui-py-3';
  const baseClasses = `${paddingClasses} sui-col-span-12 empty:sui-p-0`;

  if (plpSpeedEnabled) {
    return `${baseClasses} md:sui-col-span-6 lg:sui-col-span-6 xl:sui-col-span-5`;
  }
  return `${baseClasses} sm:sui-col-span-9`;
};

export const getSortByColumnClasses = (hideFFM, plpSpeedEnabled) => {
  const baseClasses = 'sui-pr-0 sui-col-span-12';

  if (hideFFM) {
    return baseClasses;
  }

  if (plpSpeedEnabled) {
    return `${baseClasses} md:sui-col-span-6 lg:sui-col-span-6 xl:sui-col-span-7`;
  }
  return `${baseClasses} sm:sui-col-span-3`;
};